import ProjectCalendar from "@/api/project/project-calendar";
import chartBarFactory from "@/models/factories/chart-bar-factory";
import { Project } from "@/api/project/project";
import { Task } from "@/api/project/task";
import ChartBar from "@/models/chart-bar";
import ChartRow from "@/models/chart-row";
import Period from "./period";
import ChartTaskPolicy from "./chart-task-policy";

export interface UserProjectCalendar {
  name: string;
  icon: string; // URL
  rows: ChartRow[];
}

/**
 * 各ユーザーの工程表一覧を工程ごとに出すためのモデル
 */
export function ProjectTaskChart(
  calendar: ProjectCalendar,
  period: Period
): UserProjectCalendar {
  const rows = calendar.projects.map(p => ProjectTaskChartRow(p, period));
  return {
    name: calendar.user.name,
    icon: calendar.user.icon,
    rows
  };
}

function ProjectTaskChartRow(project: Project, period: Period): ChartRow {
  const includes = new ChartTaskPolicy(period);
  return {
    id: project.id,
    label: project.name,
    actions: [],
    bars: project.tasks
      .filter(t => includes.isSatisfied(t))
      .map(t => ProjectTaskChartBar(t, period))
  };
}

function ProjectTaskChartBar(task: Task, period: Period): ChartBar {
  return {
    ...chartBarFactory.create(task, period),
    id: task.id,
    label: task.name
  };
}
